/*
 * Clase base para ser extendida por indexAfiliados, indexEmpresas e indexProvincias.
 * Contiene funcionalidad en comun para todas esas pantallas.
 */
import { size, has } from "lodash";
import React, { Component } from "react";
import { DropDownMenu, MenuItem, Chip } from "material-ui";
import { Card, CardHeader, CardText } from "material-ui/Card";
import { Toolbar, ToolbarGroup, ToolbarTitle } from "material-ui/Toolbar";
import ArgentinaMap from "../../components/SVGMaps/MapaArgentina"; //PopupArgentina
import SearchAutocompleteInput from "../../components/SearchAutocompleteInput/SearchAutocompleteInput";
import { ROL_BI_USER } from "../../common/Constants";
import { INDEX, BI_AFFILIATE } from "../../config/RoutesConstants";

export default class biBaseClass extends Component {
	constructor(props) {
		super(props);
		this.state = {
			login: this.props.login,
			fetchingData: false
		};
		this.reloadDataFromServer = this.reloadDataFromServer.bind(this);
		this.onChangeYear = this.onChangeYear.bind(this);
		this.onChangeProvincia = this.onChangeProvincia.bind(this);
		this.onRemoveProvincia = this.onRemoveProvincia.bind(this);
		this.onRemoveCiudad = this.onRemoveCiudad.bind(this);
		this.onChangeCiudad = this.onChangeCiudad.bind(this);
	}

	/*
   * Funcionalidad de provicinas
   */

	// se ejecuta al hacer cambios en la seleccion del mapa
	onChangeProvincia(selectedProvinces) {
		const { selectedCities } = this.props.biModule;
		const callback =
			size(selectedCities) > 0 ? this.reloadDataFromServer : undefined;
		this.props.actionChangeBiModuleProps(
			{
				selectedProvinces,
				selectedCities: {}
			},
			callback
		);
		if (size(selectedProvinces) === 1) {
			const prov_id = Object.keys(selectedProvinces)[0];
			this.props.actionGetCities(prov_id);
		}
	}

	// se ejecuta al borrar un chip
	onRemoveProvincia(id) {
		id = id.toString();
		let { selectedProvinces } = this.props.biModule;
		if (has(selectedProvinces, id)) {
			delete selectedProvinces[id];
			this.props.actionChangeBiModuleProps({
				selectedProvinces,
				selectedCities: {}
			});
			if (size(selectedProvinces) === 1) {
				const prov_id = Object.keys(selectedProvinces)[0];
				this.props.actionGetCities(prov_id);
			}
		}
	}

	/*
   * Funcionalidad de ciudades
   */

	// se ejecuta al borrar un chip
	onRemoveCiudad(id) {
		id = id.toString();
		let { selectedCities } = this.props.biModule;
		if (has(selectedCities, id)) {
			delete selectedCities[id];
			this.props.actionChangeBiModuleProps(
				{
					selectedCities
				},
				this.reloadDataFromServer
			);
		}
	}

	// se ejecuta al seleccionar una ciudad en el autocomplete
	onChangeCiudad(row) {
		const id = row.id.toString();
		/*
    let { selectedCities } = this.props.biModule;
    selectedCities[id] = row.name;
    */
		let selectedCities = { [id]: row.name };
		this.props.actionChangeBiModuleProps(
			{
				selectedCities
			},
			this.reloadDataFromServer
		);
	}

	componentWillMount() {
		if (this.props.rol !== ROL_BI_USER) this.props.history.push(INDEX);
	}
	componentDidMount() {
		const { year, homeStats } = this.props.biModule;
		if (homeStats.length === 0) {
			this.reloadDataFromServer();
		}
		if (this.props.provincias.length === 0) {
			this.props.actionGetProvinces();
		}
		this.props.actionChangeLocationProps({ ciudadesList: [] });
		// truco para forzar un render...
		this.props.actionChangeBiModuleProps({
			year,
			selectedProvinces: {},
			selectedCities: {}
		});
		if (this.props.location.pathname === BI_AFFILIATE) {
			this.props.actionGetAffiliateStatusCantNow();
		}
	}

	// unica funcion que busca datos del server (todas las peticiones pasan x aca)
	reloadDataFromServer() {
		const { year, selectedCities } = this.props.biModule;
		let params = { year };
		if (size(selectedCities) > 0) {
			// selecciono la primer ciudad...
			params.cityId = Object.keys(selectedCities)[0];
		}
		const callback = () => this.setState({ fetchingData: false });
		this.setState({ fetchingData: true });
		this.props.actionGetHomeStats(params, callback);
		this.props.actionGetChildrenStats();
	}

	// proceso el evento de cambio de año
	onChangeYear(event, index, year) {
		const reloadDataFromServer = this.reloadDataFromServer.bind(this);
		this.props.actionChangeBiModuleProps(
			{
				year,
				selectedProvinces: {},
				selectedCities: {}
			},
			reloadDataFromServer
		);
	}

	// Devuelvo los datos estaditicos filtrados por provincia
	getHomeStats() {
		let { selectedProvinces, homeStats } = this.props.biModule;
		if (size(selectedProvinces) === 0) {
			return homeStats;
		}
		return homeStats.filter(item => has(selectedProvinces, item.provId));
	}

	// muestro el autocomplete de ciudades: si o no?
	showAutocompleteCities() {
		const { selectedProvinces } = this.props.biModule;
		if (size(selectedProvinces) === 1) {
			return true;
		}
		return false;
	}

	/*
   * Render functions
   */

	renderCard(title, content, style = {}) {
		let cardHeader = null;
		if (title !== null || title !== undefined) {
			cardHeader = (
				<CardHeader
					textStyle={{ paddingRight: 0 }}
					style={{
						color: "#616161",
						backgroundColor: "#f3f3f3"
					}}
				>
					{title}
				</CardHeader>
			);
		}
		return (
			<Card style={style}>
				{cardHeader}
				<CardText>{content}</CardText>
			</Card>
		);
	}

	renderAutocompleteCity() {
		const { ciudades = [] } = this.props;
		if (!this.showAutocompleteCities() || size(ciudades) === 0) {
			return null;
		}
		// solo permito seleccionar una ciudad...
		const { selectedCities } = this.props.biModule;
		if (size(selectedCities) > 0) {
			return null;
		}
		return (
			<div style={{ width: "450px" }}>
				<SearchAutocompleteInput
					style={{
						paddingLeft: "10px",
						marginBottom: "18px"
					}}
					dataSource={ciudades}
					dataSourceConfig={{ text: "name", value: "id" }}
					floatingLabelText="Localidad"
					fullWidth
					onSelect={(row, index) => {
						if (index !== -1 && row.id > 0) {
							this.onChangeCiudad(row);
						}
					}}
				/>
			</div>
		);
	}

	renderHeaderChips() {
		const { selectedCities } = this.props.biModule;
		if (this.showAutocompleteCities() && size(selectedCities) > 0) {
			// muestro chips con ciudades
			return this.renderCiudadesChips();
		}
		// muestro chips con provincias
		return this.renderProvinciasChips();
	}
	renderProvinciasChips() {
		const { selectedProvinces, provincias } = this.props.biModule;
		let arrChips = [];
		if (size(selectedProvinces) === 0) {
			return arrChips;
		}
		for (let id in selectedProvinces) {
			arrChips.push(
				<Chip
					key={id}
					onRequestDelete={() => {
						this.onRemoveProvincia(id);
					}}
					backgroundColor={"#2D5986"}
					labelColor={"white"}
					deleteIconStyle={{ fill: "#76b5f5" }}
				>
					{provincias[id]}
				</Chip>
			);
		}
		return arrChips;
	}
	renderCiudadesChips() {
		const { selectedCities } = this.props.biModule;
		let arrChips = [];
		if (size(selectedCities) === 0) {
			return arrChips;
		}
		for (let id in selectedCities) {
			arrChips.push(
				<Chip
					key={id}
					onRequestDelete={() => {
						this.onRemoveCiudad(id);
					}}
					backgroundColor={"#76b5f5"}
					labelColor={"white"}
					deleteIconStyle={{ fill: "#2D5986" }}
				>
					{selectedCities[id]}
				</Chip>
			);
		}
		return arrChips;
	}

	renderHeaderYears() {
		const { year } = this.props.biModule;
		let arrYears = [];
		let current_year = new Date().getFullYear();
		for (let i = 2016; i <= current_year; i++) {
			arrYears.push(<MenuItem key={i} value={i} primaryText={i} />);
		}
		return (
			<DropDownMenu
				value={year}
				onChange={this.onChangeYear}
				labelStyle={{ lineHeight: "50px" }}
				iconStyle={{ fill: "#333", paddingTop: 5 }}
			>
				{arrYears}
			</DropDownMenu>
		);
	}

	renderHeaderReport({ title }) {
		// populate dropdowns & chips..
		const arrChips = this.renderHeaderChips();
		const selectYears = this.renderHeaderYears();
		const acCity = this.renderAutocompleteCity();
		// all done
		return (
			<div>
				<Toolbar>
					<ToolbarGroup firstChild={true}>
						<ToolbarTitle text={title} style={{ paddingLeft: "30px" }} />
					</ToolbarGroup>
					<ToolbarGroup>
						<span style={{ marginRight: 10 }}>Filtrado por:</span>
						{arrChips}
						{acCity}
						{selectYears}
					</ToolbarGroup>
				</Toolbar>
			</div>
		);
	}

	renderMapaArgentina({ type, title }) {
		return (
			<ArgentinaMap
				style={{ boxShadow: 0 }}
				type={type}
				title={title}
				onUpdate={items => this.onChangeProvincia(items)}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/screens/biCharts/BaseClass.js